import { Navigate, Outlet } from 'react-router';
import { Loading } from '@/components/Loading/Loading';
import { useCheckFeatureAccessQuery } from '@/services/ApiService';

export type FeatureAccessOutletGateProps = {
    featureKey: string;
    redirectTo: string;
};

export const FeatureAccessOutletGate = ({ featureKey, redirectTo }: FeatureAccessOutletGateProps) => {
    const { data, isLoading } = useCheckFeatureAccessQuery(featureKey);

    if (isLoading) {
        return <Loading />;
    }

    if (!data?.hasAccess) {
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
};
